import { CSSProperties } from "react";

interface ThreeBarLoaderProps {
    style?: CSSProperties
    alignTop?: boolean;
}

export default function ThreeBarLoader({style = undefined, alignTop = undefined}: ThreeBarLoaderProps) {
    return (
        <div id="shared__div__three-bar_loader_0" className={`q-loader ${alignTop ? 'alignTop' : ''}`} style={ style } >
        <svg version="1.1" id="loader" className={alignTop ? 'alignTop' : ''}>
            <path id="one" d="M5,25H0V0h5V25z" />
            <path id="two" d="M15,25h-5V0h5V25z" />
            <path id="three" d="M25,25h-5V0h5V25z" />
        </svg>
        </div>
    );
}
